<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="title"
    width="1000px"
    :close-on-click-modal="false"
    class="edi-state-query-dialog"
  >
    <el-radio-group v-model="operator" style="margin-top: 10px;">
      <el-radio no="and" label="and">{{ $t('advanceSearchForm.fitAll') }}</el-radio>
      <el-radio no="or" label="or">{{ $t('advanceSearchForm.fitAny') }}</el-radio>
    </el-radio-group>
    <div style="height: 450px;margin-top: 10px;">
      <el-form label-width="150px" :inline="true" label-position="left">
        <el-form-item :label="$t('Message.BookingEdiSendType')" style="width: 48%;">
          <el-select
            :value="sendType.condition"
            no="sendTypeCondition"
            :placeholder="$t('common.pleaseChoose')"
            style="width: 80px;"
            @input="newVal => {onConditionInput('sendType', newVal)}"
          >
            <el-option
              v-for="(item, index) in sendType.allConditions"
              :key="index"
              :label="$t('advanceSearchForm.' + item.englishName)"
              :value="item.code"
            />
          </el-select>
          <el-select v-show="sendType.condition === OPERATOR_IN.code" v-model="sendType.values" no="sendTypeValue" multiple collapse-tags :placeholder="$t('common.pleaseChoose')" style="width: 200px;margin-left: 5px;" clearable>
            <el-option v-for="(item, index) in bookingEdiSendTypeList" :key="index" :label="$store.getters.isZh ? item.chineseName : item.code" :value="item.code" />
          </el-select>
          <el-select v-show="sendType.condition !== OPERATOR_IN.code" v-model="sendType.value" no="sendTypeValue" :placeholder="$t('common.pleaseChoose')" style="width: 200px;margin-left: 5px;" clearable>
            <el-option v-for="(item, index) in bookingEdiSendTypeList" :key="index" :label="$store.getters.isZh ? item.chineseName : item.code" :value="item.code" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_BookingSendDate')" style="width: 48%;">
          <el-select
            :value="sendTime.condition"
            no="sendTimeCondition"
            :placeholder="$t('common.pleaseChoose')"
            style="width: 80px;margin-right: 5px;"
            @input="newVal => {onConditionInput('sendTime', newVal)}"
          >
            <el-option
              v-for="(item, index) in sendTime.allConditions"
              :key="index"
              :label="$t('advanceSearchForm.' + item.englishName)"
              :value="item.code"
            />
          </el-select>
          <template v-if="sendTime.condition === 'DATE ITEM'">
            <el-select v-model="sendTime.value" no="sendTimeDateItem" placeholder=" " style="width: 200px;" clearable>
              <el-option
                v-for="(item, index) in shortcutDates"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template v-else>
            <cargo-date-time-picker
              v-model="sendTime.values[0]"
              no="sendTimeBegin"
              :disabled="sendTime.condition !== 'RANGE'"
              value-format="yyyy-MM-dd"
              type="date"
              clearable
              :picker-options="{
                disabledDate: time => {
                  return (
                    time.getTime() >
                    new Date(sendTime.values[1] + ' 23:59:59').getTime()
                  )
                }
              }"
              placeholder=" "
              style="width: 110px"
            />
            <span> - </span>
            <cargo-date-time-picker
              v-model="sendTime.values[1]"
              no="sendTimeEnd"
              :disabled="sendTime.condition !== 'RANGE'"
              value-format="yyyy-MM-dd"
              type="date"
              clearable
              :picker-options="{
                disabledDate: time => {
                  return (
                    time.getTime() <
                    new Date(sendTime.values[0] + ' 00:00:00').getTime()
                  )
                }
              }"
              placeholder=" "
              style="width: 110px"
            />
          </template>
        </el-form-item>
      </el-form>
      <el-form label-width="150px" :inline="true" label-position="left">
        <el-form-item :label="$t('SeaExport.BL_EDI_SendChannel')" style="width: 48%;">
          <el-select
            :value="ladingBillSendType.condition"
            no="sendTypeCondition"
            :placeholder="$t('common.pleaseChoose')"
            style="width: 80px;"
            @input="newVal => {onConditionInput('ladingBillSendType', newVal)}"
          >
            <el-option
              v-for="(item, index) in ladingBillSendType.allConditions"
              :key="index"
              :label="$t('advanceSearchForm.' + item.englishName)"
              :value="item.code"
            />
          </el-select>
          <el-select v-show="ladingBillSendType.condition === OPERATOR_IN.code" v-model="ladingBillSendType.values" no="sendTypeValue" multiple collapse-tags :placeholder="$t('common.pleaseChoose')" style="width: 200px;margin-left: 5px;">
            <el-option v-for="(item, index) in blEdiSendChannelList" :key="index" :label="$store.getters.isZh ? item.chineseName : item.code" :value="item.code" />
          </el-select>
          <el-select v-show="ladingBillSendType.condition !== OPERATOR_IN.code" v-model="ladingBillSendType.value" no="sendTypeValue" :placeholder="$t('common.pleaseChoose')" style="width: 200px;margin-left: 5px;" clearable>
            <el-option v-for="(item, index) in blEdiSendChannelList" :key="index" :label="$store.getters.isZh ? item.chineseName : item.code" :value="item.code" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.BL_EDI_SendTime')" style="width: 48%;">
          <el-select
            :value="ladingBillSendDate.condition"
            no="sendTimeCondition"
            :placeholder="$t('common.pleaseChoose')"
            style="width: 80px;margin-right: 5px;"
            @input="newVal => {onConditionInput('ladingBillSendDate', newVal)}"
          >
            <el-option
              v-for="(item, index) in ladingBillSendDate.allConditions"
              :key="index"
              :label="$t('advanceSearchForm.' + item.englishName)"
              :value="item.code"
            />
          </el-select>
          <template v-if="ladingBillSendDate.condition === 'DATE ITEM'">
            <el-select v-model="ladingBillSendDate.value" no="sendTimeDateItem" placeholder=" " style="width: 200px;" clearable>
              <el-option
                v-for="(item, index) in shortcutDates"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template v-else>
            <cargo-date-time-picker
              v-model="ladingBillSendDate.values[0]"
              no="sendTimeBegin"
              :disabled="ladingBillSendDate.condition !== 'RANGE'"
              value-format="yyyy-MM-dd"
              type="date"
              clearable
              :picker-options="{
                disabledDate: time => {
                  return (
                    time.getTime() >
                    new Date(ladingBillSendDate.values[1] + ' 23:59:59').getTime()
                  )
                }
              }"
              placeholder=" "
              style="width: 110px"
            />
            <span> - </span>
            <cargo-date-time-picker
              v-model="ladingBillSendDate.values[1]"
              no="sendTimeEnd"
              :disabled="ladingBillSendDate.condition !== 'RANGE'"
              value-format="yyyy-MM-dd"
              type="date"
              clearable
              :picker-options="{
                disabledDate: time => {
                  return (
                    time.getTime() <
                    new Date(ladingBillSendDate.values[0] + ' 00:00:00').getTime()
                  )
                }
              }"
              placeholder=" "
              style="width: 110px"
            />
          </template>
        </el-form-item>
      </el-form>
      <el-form label-width="150px" :inline="true" label-position="left">
        <el-form-item :label="$t('SeaExport.CleanManifest_EDI_SendChannel')" style="width: 48%;">
          <el-select
            :value="ifcsumSendType.condition"
            no="sendTypeCondition"
            :placeholder="$t('common.pleaseChoose')"
            style="width: 80px;"
            @input="newVal => {onConditionInput('ifcsumSendType', newVal)}"
          >
            <el-option
              v-for="(item, index) in ifcsumSendType.allConditions"
              :key="index"
              :label="$t('advanceSearchForm.' + item.englishName)"
              :value="item.code"
            />
          </el-select>
          <el-select v-show="ifcsumSendType.condition === OPERATOR_IN.code" v-model="ifcsumSendType.values" no="sendTypeValue" multiple collapse-tags :placeholder="$t('common.pleaseChoose')" style="width: 200px;margin-left: 5px;">
            <el-option v-for="(item, index) in cleanManifestEdiSendTypeList" :key="index" :label="$store.getters.isZh ? item.chineseName : item.code" :value="item.code" />
          </el-select>
          <el-select v-show="ifcsumSendType.condition !== OPERATOR_IN.code" v-model="ifcsumSendType.value" no="sendTypeValue" :placeholder="$t('common.pleaseChoose')" style="width: 200px;margin-left: 5px;" clearable>
            <el-option v-for="(item, index) in cleanManifestEdiSendTypeList" :key="index" :label="$store.getters.isZh ? item.chineseName : item.code" :value="item.code" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.CleanManifest_EDI_SendTime')" style="width: 48%;">
          <el-select
            :value="ifcsumSendDate.condition"
            no="sendTimeCondition"
            :placeholder="$t('common.pleaseChoose')"
            style="width: 80px;margin-right: 5px;"
            @input="newVal => {onConditionInput('ifcsumSendDate', newVal)}"
          >
            <el-option
              v-for="(item, index) in ifcsumSendDate.allConditions"
              :key="index"
              :label="$t('advanceSearchForm.' + item.englishName)"
              :value="item.code"
            />
          </el-select>
          <template v-if="ifcsumSendDate.condition === 'DATE ITEM'">
            <el-select v-model="ifcsumSendDate.value" no="sendTimeDateItem" placeholder=" " style="width: 200px;" clearable>
              <el-option
                v-for="(item, index) in shortcutDates"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template v-else>
            <cargo-date-time-picker
              v-model="ifcsumSendDate.values[0]"
              no="sendTimeBegin"
              :disabled="ifcsumSendDate.condition !== 'RANGE'"
              value-format="yyyy-MM-dd"
              type="date"
              clearable
              :picker-options="{
                disabledDate: time => {
                  return (
                    time.getTime() >
                    new Date(ifcsumSendDate.values[1] + ' 23:59:59').getTime()
                  )
                }
              }"
              placeholder=" "
              style="width: 110px"
            />
            <span> - </span>
            <cargo-date-time-picker
              v-model="ifcsumSendDate.values[1]"
              no="sendTimeEnd"
              :disabled="ifcsumSendDate.condition !== 'RANGE'"
              value-format="yyyy-MM-dd"
              type="date"
              clearable
              :picker-options="{
                disabledDate: time => {
                  return (
                    time.getTime() <
                    new Date(ifcsumSendDate.values[0] + ' 00:00:00').getTime()
                  )
                }
              }"
              placeholder=" "
              style="width: 110px"
            />
          </template>
        </el-form-item>
      </el-form>
      <el-form label-width="150px" :inline="true" label-position="left">
        <el-form-item :label="$t('SeaExport.PreShippingBill_EDI_SendChannel')" style="width: 48%;">
          <el-select
            :value="preconfigureShippingSendType.condition"
            no="sendTypeCondition"
            :placeholder="$t('common.pleaseChoose')"
            style="width: 80px;"
            @input="newVal => {onConditionInput('preconfigureShippingSendType', newVal)}"
          >
            <el-option
              v-for="(item, index) in preconfigureShippingSendType.allConditions"
              :key="index"
              :label="$t('advanceSearchForm.' + item.englishName)"
              :value="item.code"
            />
          </el-select>
          <el-select v-show="preconfigureShippingSendType.condition === OPERATOR_IN.code" v-model="preconfigureShippingSendType.values" no="sendTypeValue" multiple collapse-tags :placeholder="$t('common.pleaseChoose')" style="width: 200px;margin-left: 5px;">
            <el-option v-for="(item, index) in preShippingBillEdiSendTypeList" :key="index" :label="$store.getters.isZh ? item.chineseName : item.code" :value="item.code" />
          </el-select>
          <el-select v-show="preconfigureShippingSendType.condition !== OPERATOR_IN.code" v-model="preconfigureShippingSendType.value" no="sendTypeValue" :placeholder="$t('common.pleaseChoose')" style="width: 200px;margin-left: 5px;" clearable>
            <el-option v-for="(item, index) in preShippingBillEdiSendTypeList" :key="index" :label="$store.getters.isZh ? item.chineseName : item.code" :value="item.code" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.PreShippingBill_EDI_SendTime')" style="width: 48%;">
          <el-select
            :value="preconfigureShippingSendDate.condition"
            no="sendTimeCondition"
            :placeholder="$t('common.pleaseChoose')"
            style="width: 80px;margin-right: 5px;"
            @input="newVal => {onConditionInput('preconfigureShippingSendDate', newVal)}"
          >
            <el-option
              v-for="(item, index) in preconfigureShippingSendDate.allConditions"
              :key="index"
              :label="$t('advanceSearchForm.' + item.englishName)"
              :value="item.code"
            />
          </el-select>
          <template v-if="preconfigureShippingSendDate.condition === 'DATE ITEM'">
            <el-select v-model="preconfigureShippingSendDate.value" no="sendTimeDateItem" placeholder=" " style="width: 200px;" clearable>
              <el-option
                v-for="(item, index) in shortcutDates"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template v-else>
            <cargo-date-time-picker
              v-model="preconfigureShippingSendDate.values[0]"
              no="sendTimeBegin"
              :disabled="preconfigureShippingSendDate.condition !== 'RANGE'"
              value-format="yyyy-MM-dd"
              type="date"
              clearable
              :picker-options="{
                disabledDate: time => {
                  return (
                    time.getTime() >
                    new Date(preconfigureShippingSendDate.values[1] + ' 23:59:59').getTime()
                  )
                }
              }"
              placeholder=" "
              style="width: 110px"
            />
            <span> - </span>
            <cargo-date-time-picker
              v-model="preconfigureShippingSendDate.values[1]"
              no="sendTimeEnd"
              :disabled="preconfigureShippingSendDate.condition !== 'RANGE'"
              value-format="yyyy-MM-dd"
              type="date"
              clearable
              :picker-options="{
                disabledDate: time => {
                  return (
                    time.getTime() <
                    new Date(preconfigureShippingSendDate.values[0] + ' 00:00:00').getTime()
                  )
                }
              }"
              placeholder=" "
              style="width: 110px"
            />
          </template>
        </el-form-item>
      </el-form>
      <el-form label-width="150px" :inline="true" label-position="left">
        <el-form-item :label="$t('SeaExport.OverseaAgent_EDI_SendChannel')" style="width: 48%;">
          <el-select
            :value="overseaAgentSendType.condition"
            no="sendTypeCondition"
            :placeholder="$t('common.pleaseChoose')"
            style="width: 80px;"
            @input="newVal => {onConditionInput('overseaAgentSendType', newVal)}"
          >
            <el-option
              v-for="(item, index) in overseaAgentSendType.allConditions"
              :key="index"
              :label="$t('advanceSearchForm.' + item.englishName)"
              :value="item.code"
            />
          </el-select>
          <el-select v-show="overseaAgentSendType.condition === OPERATOR_IN.code" v-model="overseaAgentSendType.values" no="sendTypeValue" multiple collapse-tags :placeholder="$t('common.pleaseChoose')" style="width: 200px;margin-left: 5px;">
            <el-option v-for="(item, index) in overseaAgentSendTypeList" :key="index" :label="$store.getters.isZh ? item.chineseName : item.code" :value="item.code" />
          </el-select>
          <el-select v-show="overseaAgentSendType.condition !== OPERATOR_IN.code" v-model="overseaAgentSendType.value" no="sendTypeValue" :placeholder="$t('common.pleaseChoose')" style="width: 200px;margin-left: 5px;" clearable>
            <el-option v-for="(item, index) in overseaAgentSendTypeList" :key="index" :label="$store.getters.isZh ? item.chineseName : item.code" :value="item.code" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.OverseaAgent_EDI_SendTime')" style="width: 48%;">
          <el-select
            :value="overseaAgentSendDate.condition"
            no="sendTimeCondition"
            :placeholder="$t('common.pleaseChoose')"
            style="width: 80px;margin-right: 5px;"
            @input="newVal => {onConditionInput('overseaAgentSendDate', newVal)}"
          >
            <el-option
              v-for="(item, index) in overseaAgentSendDate.allConditions"
              :key="index"
              :label="$t('advanceSearchForm.' + item.englishName)"
              :value="item.code"
            />
          </el-select>
          <template v-if="overseaAgentSendDate.condition === 'DATE ITEM'">
            <el-select v-model="overseaAgentSendDate.value" no="sendTimeDateItem" placeholder=" " style="width: 200px;" clearable>
              <el-option
                v-for="(item, index) in shortcutDates"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template v-else>
            <cargo-date-time-picker
              v-model="overseaAgentSendDate.values[0]"
              no="sendTimeBegin"
              :disabled="overseaAgentSendDate.condition !== 'RANGE'"
              value-format="yyyy-MM-dd"
              type="date"
              clearable
              :picker-options="{
                disabledDate: time => {
                  return (
                    time.getTime() >
                    new Date(overseaAgentSendDate.values[1] + ' 23:59:59').getTime()
                  )
                }
              }"
              placeholder=" "
              style="width: 110px"
            />
            <span> - </span>
            <cargo-date-time-picker
              v-model="overseaAgentSendDate.values[1]"
              no="sendTimeEnd"
              :disabled="overseaAgentSendDate.condition !== 'RANGE'"
              value-format="yyyy-MM-dd"
              type="date"
              clearable
              :picker-options="{
                disabledDate: time => {
                  return (
                    time.getTime() <
                    new Date(overseaAgentSendDate.values[0] + ' 00:00:00').getTime()
                  )
                }
              }"
              placeholder=" "
              style="width: 110px"
            />
          </template>
        </el-form-item>
      </el-form>
      <!-- 提箱单EDI发送时间  -->
      <!--      <el-form label-width="150px" :inline="true" label-position="left">-->
      <!--        <el-form-item style="width: 48%;" />-->
      <!--        <el-form-item :label="$t('SeaExport.Packing_EDI_SendTime')" style="width: 48%;">-->
      <!--          <el-select-->
      <!--            :value="installSendDate.condition"-->
      <!--            no="sendTimeCondition"-->
      <!--            :placeholder="$t('common.pleaseChoose')"-->
      <!--            style="width: 80px;margin-right: 5px;"-->
      <!--            @input="newVal => {onConditionInput('installSendDate', newVal)}"-->
      <!--          >-->
      <!--            <el-option-->
      <!--              v-for="(item, index) in installSendDate.allConditions"-->
      <!--              :key="index"-->
      <!--              :label="$t('advanceSearchForm.' + item.englishName)"-->
      <!--              :value="item.code"-->
      <!--            />-->
      <!--          </el-select>-->
      <!--          <template v-if="installSendDate.condition === 'DATE ITEM'">-->
      <!--            <el-select v-model="installSendDate.value" no="sendTimeDateItem" placeholder=" " style="width: 200px;" clearable>-->
      <!--              <el-option-->
      <!--                v-for="(item, index) in shortcutDates"-->
      <!--                :key="index"-->
      <!--                :label="item.label"-->
      <!--                :value="item.value"-->
      <!--              />-->
      <!--            </el-select>-->
      <!--          </template>-->
      <!--          <template v-else>-->
      <!--            <cargo-date-time-picker-->
      <!--              v-model="installSendDate.values[0]"-->
      <!--              no="sendTimeBegin"-->
      <!--              :disabled="installSendDate.condition !== 'RANGE'"-->
      <!--              value-format="yyyy-MM-dd"-->
      <!--              type="date"-->
      <!--              clearable-->
      <!--              :picker-options="{-->
      <!--                disabledDate: time => {-->
      <!--                  return (-->
      <!--                    time.getTime() >-->
      <!--                    new Date(installSendDate.values[1] + ' 23:59:59').getTime()-->
      <!--                  )-->
      <!--                }-->
      <!--              }"-->
      <!--              placeholder=" "-->
      <!--              style="width: 110px"-->
      <!--            />-->
      <!--            <span> - </span>-->
      <!--            <cargo-date-time-picker-->
      <!--              v-model="installSendDate.values[1]"-->
      <!--              no="sendTimeEnd"-->
      <!--              :disabled="installSendDate.condition !== 'RANGE'"-->
      <!--              value-format="yyyy-MM-dd"-->
      <!--              type="date"-->
      <!--              clearable-->
      <!--              :picker-options="{-->
      <!--                disabledDate: time => {-->
      <!--                  return (-->
      <!--                    time.getTime() <-->
      <!--                    new Date(installSendDate.values[0] + ' 00:00:00').getTime()-->
      <!--                  )-->
      <!--                }-->
      <!--              }"-->
      <!--              placeholder=" "-->
      <!--              style="width: 110px"-->
      <!--            />-->
      <!--          </template>-->
      <!--        </el-form-item>-->
      <!--      </el-form>-->
      <el-form label-width="150px" :inline="true" label-position="left">
        <el-form-item style="width: 48%;" />
        <el-form-item :label="$t('SeaExport.AMS_EDI_SendTime')" style="width: 48%;">
          <el-select
            :value="amsSendDate.condition"
            no="sendTimeCondition"
            :placeholder="$t('common.pleaseChoose')"
            style="width: 80px;margin-right: 5px;"
            @input="newVal => {onConditionInput('amsSendDate', newVal)}"
          >
            <el-option
              v-for="(item, index) in amsSendDate.allConditions"
              :key="index"
              :label="$t('advanceSearchForm.' + item.englishName)"
              :value="item.code"
            />
          </el-select>
          <template v-if="amsSendDate.condition === 'DATE ITEM'">
            <el-select v-model="amsSendDate.value" no="sendTimeDateItem" placeholder=" " style="width: 200px;" clearable>
              <el-option
                v-for="(item, index) in shortcutDates"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template v-else>
            <cargo-date-time-picker
              v-model="amsSendDate.values[0]"
              no="sendTimeBegin"
              :disabled="amsSendDate.condition !== 'RANGE'"
              value-format="yyyy-MM-dd"
              type="date"
              clearable
              :picker-options="{
                disabledDate: time => {
                  return (
                    time.getTime() >
                    new Date(amsSendDate.values[1] + ' 23:59:59').getTime()
                  )
                }
              }"
              placeholder=" "
              style="width: 110px"
            />
            <span> - </span>
            <cargo-date-time-picker
              v-model="amsSendDate.values[1]"
              no="sendTimeEnd"
              :disabled="amsSendDate.condition !== 'RANGE'"
              value-format="yyyy-MM-dd"
              type="date"
              clearable
              :picker-options="{
                disabledDate: time => {
                  return (
                    time.getTime() <
                    new Date(amsSendDate.values[0] + ' 00:00:00').getTime()
                  )
                }
              }"
              placeholder=" "
              style="width: 110px"
            />
          </template>
        </el-form-item>
      </el-form>
      <el-form label-width="150px" :inline="true" label-position="left">
        <el-form-item style="width: 48%;" />
        <el-form-item :label="$t('SeaExport.AHR_EDI_SendTime')" style="width: 48%;">
          <el-select
            :value="ahrSendDate.condition"
            no="sendTimeCondition"
            :placeholder="$t('common.pleaseChoose')"
            style="width: 80px;margin-right: 5px;"
            @input="newVal => {onConditionInput('ahrSendDate', newVal)}"
          >
            <el-option
              v-for="(item, index) in ahrSendDate.allConditions"
              :key="index"
              :label="$t('advanceSearchForm.' + item.englishName)"
              :value="item.code"
            />
          </el-select>
          <template v-if="ahrSendDate.condition === 'DATE ITEM'">
            <el-select v-model="ahrSendDate.value" no="sendTimeDateItem" placeholder=" " style="width: 200px;" clearable>
              <el-option
                v-for="(item, index) in shortcutDates"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template v-else>
            <cargo-date-time-picker
              v-model="ahrSendDate.values[0]"
              no="sendTimeBegin"
              :disabled="ahrSendDate.condition !== 'RANGE'"
              value-format="yyyy-MM-dd"
              type="date"
              clearable
              :picker-options="{
                disabledDate: time => {
                  return (
                    time.getTime() >
                    new Date(ahrSendDate.values[1] + ' 23:59:59').getTime()
                  )
                }
              }"
              placeholder=" "
              style="width: 110px"
            />
            <span> - </span>
            <cargo-date-time-picker
              v-model="ahrSendDate.values[1]"
              no="sendTimeEnd"
              :disabled="ahrSendDate.condition !== 'RANGE'"
              value-format="yyyy-MM-dd"
              type="date"
              clearable
              :picker-options="{
                disabledDate: time => {
                  return (
                    time.getTime() <
                    new Date(ahrSendDate.values[0] + ' 00:00:00').getTime()
                  )
                }
              }"
              placeholder=" "
              style="width: 110px"
            />
          </template>
        </el-form-item>
      </el-form>
      <el-form label-width="150px" :inline="true" label-position="left">
        <el-form-item style="width: 48%;" />
        <el-form-item :label="$t('CargoMsg.Cargo_BookingReceiptDate')" style="width: 48%;">
          <el-select
            :value="receiptTime.condition"
            no="receiptTimeCondition"
            :placeholder="$t('common.pleaseChoose')"
            style="width: 80px;margin-right: 5px;"
            @input="newVal => {onConditionInput('receiptTime', newVal)}"
          >
            <el-option
              v-for="(item, index) in receiptTime.allConditions"
              :key="index"
              :label="$t('advanceSearchForm.' + item.englishName)"
              :value="item.code"
            />
          </el-select>
          <template v-if="receiptTime.condition === 'DATE ITEM'">
            <el-select v-model="receiptTime.value" no="receiptTimeDateItem" placeholder=" " style="width: 200px;" clearable>
              <el-option
                v-for="(item, index) in shortcutDates"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template v-else>
            <cargo-date-time-picker
              v-model="receiptTime.values[0]"
              no="receiptTimeBegin"
              :disabled="receiptTime.condition !== 'RANGE'"
              value-format="yyyy-MM-dd"
              type="date"
              clearable
              :picker-options="{
                disabledDate: time => {
                  return (
                    time.getTime() >
                    new Date(receiptTime.values[1] + ' 23:59:59').getTime()
                  )
                }
              }"
              placeholder=" "
              style="width: 110px"
            />
            <span> - </span>
            <cargo-date-time-picker
              v-model="receiptTime.values[1]"
              no="receiptTimeEnd"
              :disabled="receiptTime.condition !== 'RANGE'"
              value-format="yyyy-MM-dd"
              type="date"
              clearable
              :picker-options="{
                disabledDate: time => {
                  return (
                    time.getTime() <
                    new Date(receiptTime.values[0] + ' 00:00:00').getTime()
                  )
                }
              }"
              placeholder=" "
              style="width: 110px"
            />
          </template>
        </el-form-item>
      </el-form>
      <el-form label-width="150px" :inline="true" label-position="left">
        <el-form-item style="width: 48%;" />
        <el-form-item :label="$t('SeaExport.ENS_EDI_SendTime')" style="width: 48%;">
          <el-select
            :value="ensSendDate.condition"
            no="sendTimeCondition"
            :placeholder="$t('common.pleaseChoose')"
            style="width: 80px;margin-right: 5px;"
            @input="newVal => {onConditionInput('ensSendDate', newVal)}"
          >
            <el-option
              v-for="(item, index) in ensSendDate.allConditions"
              :key="index"
              :label="$t('advanceSearchForm.' + item.englishName)"
              :value="item.code"
            />
          </el-select>
          <template v-if="ensSendDate.condition === 'DATE ITEM'">
            <el-select v-model="ensSendDate.value" no="sendTimeDateItem" placeholder=" " style="width: 200px;" clearable>
              <el-option
                v-for="(item, index) in shortcutDates"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template v-else>
            <cargo-date-time-picker
              v-model="ensSendDate.values[0]"
              no="sendTimeBegin"
              :disabled="ensSendDate.condition !== 'RANGE'"
              value-format="yyyy-MM-dd"
              type="date"
              clearable
              :picker-options="{
                disabledDate: time => {
                  return (
                    time.getTime() >
                    new Date(ensSendDate.values[1] + ' 23:59:59').getTime()
                  )
                }
              }"
              placeholder=" "
              style="width: 110px"
            />
            <span> - </span>
            <cargo-date-time-picker
              v-model="ensSendDate.values[1]"
              no="sendTimeEnd"
              :disabled="ensSendDate.condition !== 'RANGE'"
              value-format="yyyy-MM-dd"
              type="date"
              clearable
              :picker-options="{
                disabledDate: time => {
                  return (
                    time.getTime() <
                    new Date(ensSendDate.values[0] + ' 00:00:00').getTime()
                  )
                }
              }"
              placeholder=" "
              style="width: 110px"
            />
          </template>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer">
      <el-button no="confirm" type="primary" @click="onConfirm">{{ $t('common.confirm') }}</el-button>
      <el-button no="reset" type="danger" @click="onReset">{{ $t('common.reset') }}</el-button>
      <el-button no="cancel" @click="innerVisible = false">{{ $t('common.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import CargoDateTimePicker from '@/components/Cargo/Common/CargoDateTimePicker'
import moment from 'moment'
import { isNumber } from '@/utils/validate'
import * as ChargeItemTarget from '@/class/cargo/model/parameters/ChargeItemTarget'
import {
  OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN,
  OPERATOR_RANGE, OPERATOR_DATE_ITEM, OPERATOR_IS_NULL, OPERATOR_IS_NOT_NULL
} from '@/class/cargo/model/utils/AdvancedSearchConsts'
import { getLoading } from '@/utils/utilBaseElement'
import { getEDITemplate } from '@/api/sysManage/baseConfig/ediTemplate'
import { BC_EDI_TYPE, JCL_EDI_TYPE } from '@/class/cargo/model/parameters/EdiType'

export default {
  name: 'EdiStateQueryDialog',
  components: { CargoDateTimePicker },
  props: {
    visible: { type: Boolean, required: true },
    title: { type: String, required: true },
    value: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: this.visible,
      OPERATOR_IN,
      MODEL_TYPES: ChargeItemTarget.MODEL_TYPES,
      shortcutDates: [
        { label: this.$t('advanceSearchForm.nowWeek'), value: 0 },
        { label: this.$t('advanceSearchForm.preWeek'), value: 1 },
        { label: this.$t('advanceSearchForm.nextWeek'), value: 2 },
        { label: this.$t('advanceSearchForm.nowMonth'), value: 3 },
        { label: this.$t('advanceSearchForm.preMonth'), value: 4 },
        { label: this.$t('advanceSearchForm.nextMonth'), value: 5 }
      ],
      operator: 'and',
      // 订舱预审edi
      sendType: {
        allConditions: [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN],
        condition: OPERATOR_EQUAL.code,
        value: '',
        values: [],
        ediType: 1
      },
      sendTime: {
        allConditions: [OPERATOR_RANGE, OPERATOR_DATE_ITEM, OPERATOR_IS_NULL, OPERATOR_IS_NOT_NULL],
        condition: OPERATOR_RANGE.code,
        value: '',
        values: ['', ''],
        ediType: 1
      },
      receiptTime: {
        allConditions: [OPERATOR_RANGE, OPERATOR_DATE_ITEM, OPERATOR_IS_NULL, OPERATOR_IS_NOT_NULL],
        condition: OPERATOR_RANGE.code,
        value: '',
        values: ['', ''],
        ediType: BC_EDI_TYPE.code
      },
      // 提单EDI
      ladingBillSendType: {
        allConditions: [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN],
        condition: OPERATOR_EQUAL.code,
        value: '',
        values: [],
        ediType: 2
      },
      ladingBillSendDate: {
        allConditions: [OPERATOR_RANGE, OPERATOR_DATE_ITEM, OPERATOR_IS_NULL, OPERATOR_IS_NOT_NULL],
        condition: OPERATOR_RANGE.code,
        value: '',
        values: ['', ''],
        ediType: 2
      },
      // VGM EDI
      vgmSendType: {
        allConditions: [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN],
        condition: OPERATOR_EQUAL.code,
        value: '',
        values: [],
        ediType: 11
      },
      vgmSendDate: {
        allConditions: [OPERATOR_RANGE, OPERATOR_DATE_ITEM, OPERATOR_IS_NULL, OPERATOR_IS_NOT_NULL],
        condition: OPERATOR_RANGE.code,
        value: '',
        values: ['', ''],
        ediType: 11
      },
      // 清洁舱单 EDI
      ifcsumSendType: {
        allConditions: [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN],
        condition: OPERATOR_EQUAL.code,
        value: '',
        values: [],
        ediType: 7
      },
      ifcsumSendDate: {
        allConditions: [OPERATOR_RANGE, OPERATOR_DATE_ITEM, OPERATOR_IS_NULL, OPERATOR_IS_NOT_NULL],
        condition: OPERATOR_RANGE.code,
        value: '',
        values: ['', ''],
        ediType: 7
      },
      // 电子安箱单 EDI
      installSendType: {
        allConditions: [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN],
        condition: OPERATOR_EQUAL.code,
        value: '',
        values: [],
        ediType: 4
      },
      installSendDate: {
        allConditions: [OPERATOR_RANGE, OPERATOR_DATE_ITEM, OPERATOR_IS_NULL, OPERATOR_IS_NOT_NULL],
        condition: OPERATOR_RANGE.code,
        value: '',
        values: ['', ''],
        ediType: 4
      },
      // AMS EDI
      amsSendType: {
        allConditions: [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN],
        condition: OPERATOR_EQUAL.code,
        value: '',
        values: [],
        ediType: 10
      },
      amsSendDate: {
        allConditions: [OPERATOR_RANGE, OPERATOR_DATE_ITEM, OPERATOR_IS_NULL, OPERATOR_IS_NOT_NULL],
        condition: OPERATOR_RANGE.code,
        value: '',
        values: ['', ''],
        ediType: 10
      },
      ahrSendDate: {
        allConditions: [OPERATOR_RANGE, OPERATOR_DATE_ITEM, OPERATOR_IS_NULL, OPERATOR_IS_NOT_NULL],
        condition: OPERATOR_RANGE.code,
        value: '',
        values: ['', ''],
        ediType: 8
      },
      ensSendDate: {
        allConditions: [OPERATOR_RANGE, OPERATOR_DATE_ITEM, OPERATOR_IS_NULL, OPERATOR_IS_NOT_NULL],
        condition: OPERATOR_RANGE.code,
        value: '',
        values: ['', ''],
        ediType: 38
      },
      // 预配舱单 EDI
      preconfigureShippingSendType: {
        allConditions: [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN],
        condition: OPERATOR_EQUAL.code,
        value: '',
        values: [],
        ediType: 6
      },
      preconfigureShippingSendDate: {
        allConditions: [OPERATOR_RANGE, OPERATOR_DATE_ITEM, OPERATOR_IS_NULL, OPERATOR_IS_NOT_NULL],
        condition: OPERATOR_RANGE.code,
        value: '',
        values: ['', ''],
        ediType: 6
      },
      // 海外代理 EDI
      overseaAgentSendType: {
        allConditions: [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN],
        condition: OPERATOR_EQUAL.code,
        value: '',
        values: [],
        ediType: JCL_EDI_TYPE.code
      },
      overseaAgentSendDate: {
        allConditions: [OPERATOR_RANGE, OPERATOR_DATE_ITEM, OPERATOR_IS_NULL, OPERATOR_IS_NOT_NULL],
        condition: OPERATOR_RANGE.code,
        value: '',
        values: ['', ''],
        ediType: JCL_EDI_TYPE.code
      },
      templateList: [],
      loading: false,
      bookingEdiSendTypeList: [],
      blEdiSendChannelList: [],
      cleanManifestEdiSendTypeList: [],
      packingEdiSendTypeList: [],
      preShippingBillEdiSendTypeList: [],
      overseaAgentSendTypeList: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.init()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.innerVisible) {
      this.init()
    }
  },
  methods: {
    async init() {
      this.operator = this.value.operator || 'and'
      this.sendType.condition = OPERATOR_EQUAL.code
      this.sendType.value = ''
      this.sendType.values = []
      this.sendTime.condition = OPERATOR_RANGE.code
      this.sendTime.value = ''
      this.sendTime.values = ['', '']
      this.receiptTime.condition = OPERATOR_RANGE.code
      this.receiptTime.value = ''
      this.receiptTime.values = ['', '']
      this.ladingBillSendType.condition = OPERATOR_EQUAL.code
      this.ladingBillSendType.value = ''
      this.ladingBillSendType.values = []
      this.ladingBillSendDate.condition = OPERATOR_RANGE.code
      this.ladingBillSendDate.value = ''
      this.ladingBillSendDate.values = ['', '']
      this.vgmSendType.condition = OPERATOR_EQUAL.code
      this.vgmSendType.value = ''
      this.vgmSendType.values = []
      this.vgmSendDate.condition = OPERATOR_RANGE.code
      this.vgmSendDate.value = ''
      this.vgmSendDate.values = ['', '']
      this.ifcsumSendType.condition = OPERATOR_EQUAL.code
      this.ifcsumSendType.value = ''
      this.ifcsumSendType.values = []
      this.ifcsumSendDate.condition = OPERATOR_RANGE.code
      this.ifcsumSendDate.value = ''
      this.ifcsumSendDate.values = ['', '']
      this.installSendType.condition = OPERATOR_EQUAL.code
      this.installSendType.value = ''
      this.installSendType.values = []
      this.installSendDate.condition = OPERATOR_RANGE.code
      this.installSendDate.value = ''
      this.installSendDate.values = ['', '']
      this.amsSendType.condition = OPERATOR_EQUAL.code
      this.amsSendType.value = ''
      this.amsSendType.values = []
      this.amsSendDate.condition = OPERATOR_RANGE.code
      this.amsSendDate.value = ''
      this.amsSendDate.values = ['', '']
      this.preconfigureShippingSendType.condition = OPERATOR_EQUAL.code
      this.preconfigureShippingSendType.value = ''
      this.preconfigureShippingSendType.values = []
      this.overseaAgentSendType.condition = OPERATOR_EQUAL.code
      this.overseaAgentSendType.value = ''
      this.overseaAgentSendType.values = []
      this.preconfigureShippingSendDate.condition = OPERATOR_RANGE.code
      this.preconfigureShippingSendDate.value = ''
      this.preconfigureShippingSendDate.values = ['', '']
      this.overseaAgentSendDate.condition = OPERATOR_RANGE.code
      this.overseaAgentSendDate.value = ''
      this.overseaAgentSendDate.values = ['', '']
      if (this.value.items) {
        console.log(this.value.items)
        for (const item of this.value.items) {
          if (item.fieldName === 'edi.SEND_TYPE' && item.ediType === 1) {
            this.sendType.condition = item.operator
            if (item.value instanceof Array) {
              this.sendType.values = item.value
            } else {
              this.sendType.value = item.value
            }
          } else if (item.fieldName === 'edi.DATE_CREATED' && item.ediType === 1) {
            if (item.originValue instanceof Array) {
              this.sendTime.values = item.originValue
              this.sendTime.condition = item.operator
            } else {
              this.sendTime.value = item.originValue
              this.sendTime.condition = OPERATOR_DATE_ITEM.code
            }
          } else if (item.fieldName === 'edi.RECEIPT_DATE' && item.ediType === BC_EDI_TYPE.code) {
            if (item.originValue instanceof Array) {
              this.receiptTime.values = item.originValue
              this.receiptTime.condition = item.operator
            } else {
              this.receiptTime.value = item.originValue
              this.receiptTime.condition = OPERATOR_DATE_ITEM.code
            }
          } else if (item.fieldName === 'edi.SEND_TYPE' && item.ediType === 2) {
            this.ladingBillSendType.condition = item.operator
            if (item.value instanceof Array) {
              this.ladingBillSendType.values = item.value
            } else {
              this.ladingBillSendType.value = item.value
            }
          } else if (item.fieldName === 'edi.DATE_CREATED' && item.ediType === 2) {
            if (item.originValue instanceof Array) {
              this.ladingBillSendDate.values = item.originValue
              this.ladingBillSendDate.condition = item.operator
            } else {
              this.ladingBillSendDate.value = item.originValue
              this.ladingBillSendDate.condition = OPERATOR_DATE_ITEM.code
            }
          } else if (item.fieldName === 'edi.SEND_TYPE' && item.ediType === 11) {
            this.vgmSendType.condition = item.operator
            if (item.value instanceof Array) {
              this.vgmSendType.values = item.value
            } else {
              this.vgmSendType.value = item.value
            }
          } else if (item.fieldName === 'edi.DATE_CREATED' && item.ediType === 11) {
            if (item.originValue instanceof Array) {
              this.vgmSendDate.values = item.originValue
              this.vgmSendDate.condition = item.operator
            } else {
              this.vgmSendDate.value = item.originValue
              this.vgmSendDate.condition = OPERATOR_DATE_ITEM.code
            }
          } else if (item.fieldName === 'edi.SEND_TYPE' && item.ediType === 7) {
            this.ifcsumSendType.condition = item.operator
            if (item.value instanceof Array) {
              this.ifcsumSendType.values = item.value
            } else {
              this.ifcsumSendType.value = item.value
            }
          } else if (item.fieldName === 'edi.DATE_CREATED' && item.ediType === 7) {
            if (item.originValue instanceof Array) {
              this.ifcsumSendDate.values = item.originValue
              this.ifcsumSendDate.condition = item.operator
            } else {
              this.ifcsumSendDate.value = item.originValue
              this.ifcsumSendDate.condition = OPERATOR_DATE_ITEM.code
            }
          } else if (item.fieldName === 'edi.SEND_TYPE' && item.ediType === 4) {
            this.installSendType.condition = item.operator
            if (item.value instanceof Array) {
              this.installSendType.values = item.value
            } else {
              this.installSendType.value = item.value
            }
          } else if (item.fieldName === 'edi.DATE_CREATED' && item.ediType === 4) {
            if (item.originValue instanceof Array) {
              this.installSendDate.values = item.originValue
              this.installSendDate.condition = item.operator
            } else {
              this.installSendDate.value = item.originValue
              this.installSendDate.condition = OPERATOR_DATE_ITEM.code
            }
          } else if (item.fieldName === 'edi.SEND_TYPE' && item.ediType === 10) {
            this.amsSendType.condition = item.operator
            if (item.value instanceof Array) {
              this.amsSendType.values = item.value
            } else {
              this.amsSendType.value = item.value
            }
          } else if (item.fieldName === 'edi.DATE_CREATED' && item.ediType === 10) {
            if (item.originValue instanceof Array) {
              this.amsSendDate.values = item.originValue
              this.amsSendDate.condition = item.operator
            } else {
              this.amsSendDate.value = item.originValue
              this.amsSendDate.condition = OPERATOR_DATE_ITEM.code
            }
          } else if (item.fieldName === 'edi.DATE_CREATED' && item.ediType === 8) {
            if (item.originValue instanceof Array) {
              this.ahrSendDate.values = item.originValue
              this.ahrSendDate.condition = item.operator
            } else {
              this.ahrSendDate.value = item.originValue
              this.ahrSendDate.condition = OPERATOR_DATE_ITEM.code
            }
          } else if (item.fieldName === 'edi.DATE_CREATED' && item.ediType === 38) {
            if (item.originValue instanceof Array) {
              this.ensSendDate.values = item.originValue
              this.ensSendDate.condition = item.operator
            } else {
              this.ensSendDate.value = item.originValue
              this.ensSendDate.condition = OPERATOR_DATE_ITEM.code
            }
          } else if (item.fieldName === 'edi.SEND_TYPE' && item.ediType === 6) {
            this.preconfigureShippingSendType.condition = item.operator
            if (item.value instanceof Array) {
              this.preconfigureShippingSendType.values = item.value
            } else {
              this.preconfigureShippingSendType.value = item.value
            }
          } else if (item.fieldName === 'edi.DATE_CREATED' && item.ediType === 6) {
            if (item.originValue instanceof Array) {
              this.preconfigureShippingSendDate.values = item.originValue
              this.preconfigureShippingSendDate.condition = item.operator
            } else {
              this.preconfigureShippingSendDate.value = item.originValue
              this.preconfigureShippingSendDate.condition = OPERATOR_DATE_ITEM.code
            }
          } else if (item.fieldName === 'edi.SEND_TYPE' && item.ediType === JCL_EDI_TYPE.code) {
            this.overseaAgentSendType.condition = item.operator
            if (item.value instanceof Array) {
              this.overseaAgentSendType.values = item.value
            } else {
              this.overseaAgentSendType.value = item.value
            }
          } else if (item.fieldName === 'edi.DATE_CREATED' && item.ediType === JCL_EDI_TYPE.code) {
            if (item.originValue instanceof Array) {
              this.overseaAgentSendDate.values = item.originValue
              this.overseaAgentSendDate.condition = item.operator
            } else {
              this.overseaAgentSendDate.value = item.originValue
              this.overseaAgentSendDate.condition = OPERATOR_DATE_ITEM.code
            }
          }
        }
      }
      await this.fetchEDITemplateList()
    },
    onConditionInput(fieldName, newVal) {
      switch (fieldName) {
        case 'sendType':
          if (newVal === OPERATOR_IN.code) {
            this.sendType.value = ''
          } else if (this.sendType.condition === OPERATOR_IN.code) {
            this.sendType.values = []
          }
          this.sendType.condition = newVal
          break
        case 'sendTime':
          switch (newVal) {
            case OPERATOR_RANGE.code:
              this.sendTime.value = ''
              break
            case OPERATOR_DATE_ITEM.code:
              this.sendTime.values = ['', '']
              break
            case OPERATOR_IS_NULL.code:
            case OPERATOR_IS_NOT_NULL.code:
              this.sendTime.value = ''
              this.sendTime.values = ['', '']
              break
          }
          this.sendTime.condition = newVal
          break
        case 'receiptTime':
          switch (newVal) {
            case OPERATOR_RANGE.code:
              this.receiptTime.value = ''
              break
            case OPERATOR_DATE_ITEM.code:
              this.receiptTime.values = ['', '']
              break
            case OPERATOR_IS_NULL.code:
            case OPERATOR_IS_NOT_NULL.code:
              this.receiptTime.value = ''
              this.receiptTime.values = ['', '']
              break
          }
          this.receiptTime.condition = newVal
          break
        case 'ladingBillSendType':
          if (newVal === OPERATOR_IN.code) {
            this.ladingBillSendType.value = ''
          } else if (this.ladingBillSendType.condition === OPERATOR_IN.code) {
            this.ladingBillSendType.values = []
          }
          this.ladingBillSendType.condition = newVal
          break
        case 'ladingBillSendDate':
          switch (newVal) {
            case OPERATOR_RANGE.code:
              this.ladingBillSendDate.value = ''
              break
            case OPERATOR_DATE_ITEM.code:
              this.ladingBillSendDate.values = ['', '']
              break
            case OPERATOR_IS_NULL.code:
            case OPERATOR_IS_NOT_NULL.code:
              this.ladingBillSendDate.value = ''
              this.ladingBillSendDate.values = ['', '']
              break
          }
          this.ladingBillSendDate.condition = newVal
          break
        case 'vgmSendType':
          if (newVal === OPERATOR_IN.code) {
            this.vgmSendType.value = ''
          } else if (this.vgmSendType.condition === OPERATOR_IN.code) {
            this.vgmSendType.values = []
          }
          this.vgmSendType.condition = newVal
          break
        case 'vgmSendDate':
          switch (newVal) {
            case OPERATOR_RANGE.code:
              this.vgmSendDate.value = ''
              break
            case OPERATOR_DATE_ITEM.code:
              this.vgmSendDate.values = ['', '']
              break
            case OPERATOR_IS_NULL.code:
            case OPERATOR_IS_NOT_NULL.code:
              this.vgmSendDate.value = ''
              this.vgmSendDate.values = ['', '']
              break
          }
          this.vgmSendDate.condition = newVal
          break
        case 'ifcsumSendType':
          if (newVal === OPERATOR_IN.code) {
            this.ifcsumSendType.value = ''
          } else if (this.ifcsumSendType.condition === OPERATOR_IN.code) {
            this.ifcsumSendType.values = []
          }
          this.ifcsumSendType.condition = newVal
          break
        case 'ifcsumSendDate':
          switch (newVal) {
            case OPERATOR_RANGE.code:
              this.ifcsumSendDate.value = ''
              break
            case OPERATOR_DATE_ITEM.code:
              this.ifcsumSendDate.values = ['', '']
              break
            case OPERATOR_IS_NULL.code:
            case OPERATOR_IS_NOT_NULL.code:
              this.ifcsumSendDate.value = ''
              this.ifcsumSendDate.values = ['', '']
              break
          }
          this.ifcsumSendDate.condition = newVal
          break
        case 'installSendType':
          if (newVal === OPERATOR_IN.code) {
            this.installSendType.value = ''
          } else if (this.installSendType.condition === OPERATOR_IN.code) {
            this.installSendType.values = []
          }
          this.installSendType.condition = newVal
          break
        case 'installSendDate':
          switch (newVal) {
            case OPERATOR_RANGE.code:
              this.installSendDate.value = ''
              break
            case OPERATOR_DATE_ITEM.code:
              this.installSendDate.values = ['', '']
              break
            case OPERATOR_IS_NULL.code:
            case OPERATOR_IS_NOT_NULL.code:
              this.installSendDate.value = ''
              this.installSendDate.values = ['', '']
              break
          }
          this.installSendDate.condition = newVal
          break
        case 'amsSendType':
          if (newVal === OPERATOR_IN.code) {
            this.amsSendType.value = ''
          } else if (this.amsSendType.condition === OPERATOR_IN.code) {
            this.amsSendType.values = []
          }
          this.amsSendType.condition = newVal
          break
        case 'amsSendDate':
          switch (newVal) {
            case OPERATOR_RANGE.code:
              this.amsSendDate.value = ''
              break
            case OPERATOR_DATE_ITEM.code:
              this.amsSendDate.values = ['', '']
              break
            case OPERATOR_IS_NULL.code:
            case OPERATOR_IS_NOT_NULL.code:
              this.amsSendDate.value = ''
              this.amsSendDate.values = ['', '']
              break
          }
          this.amsSendDate.condition = newVal
          break
        case 'preconfigureShippingSendType':
          if (newVal === OPERATOR_IN.code) {
            this.preconfigureShippingSendType.value = ''
          } else if (this.preconfigureShippingSendType.condition === OPERATOR_IN.code) {
            this.preconfigureShippingSendType.values = []
          }
          this.preconfigureShippingSendType.condition = newVal
          break
        case 'preconfigureShippingSendDate':
          switch (newVal) {
            case OPERATOR_RANGE.code:
              this.preconfigureShippingSendDate.value = ''
              break
            case OPERATOR_DATE_ITEM.code:
              this.preconfigureShippingSendDate.values = ['', '']
              break
            case OPERATOR_IS_NULL.code:
            case OPERATOR_IS_NOT_NULL.code:
              this.preconfigureShippingSendDate.value = ''
              this.preconfigureShippingSendDate.values = ['', '']
              break
          }
          this.preconfigureShippingSendDate.condition = newVal
          break
        case 'overseaAgentSendType':
          if (newVal === OPERATOR_IN.code) {
            this.overseaAgentSendType.value = ''
          } else if (this.overseaAgentSendType.condition === OPERATOR_IN.code) {
            this.overseaAgentSendType.values = []
          }
          this.overseaAgentSendType.condition = newVal
          break
        case 'overseaAgentSendDate':
          switch (newVal) {
            case OPERATOR_RANGE.code:
              this.overseaAgentSendDate.value = ''
              break
            case OPERATOR_DATE_ITEM.code:
              this.overseaAgentSendDate.values = ['', '']
              break
            case OPERATOR_IS_NULL.code:
            case OPERATOR_IS_NOT_NULL.code:
              this.overseaAgentSendDate.value = ''
              this.overseaAgentSendDate.values = ['', '']
              break
          }
          this.overseaAgentSendDate.condition = newVal
          break
      }
    },
    onConfirm: function() {
      const items = []
      let txtContent = ''
      const conditions = []
      conditions.push(this.buildTypeConditions(items, this.sendType))
      conditions.push(this.buildTimeConditions(items, this.sendTime))
      conditions.push(this.buildReceiptTimeConditions(items, this.receiptTime))
      conditions.push(this.buildTypeConditions(items, this.ladingBillSendType))
      conditions.push(this.buildTimeConditions(items, this.ladingBillSendDate))
      conditions.push(this.buildTypeConditions(items, this.vgmSendType))
      conditions.push(this.buildTimeConditions(items, this.vgmSendDate))
      conditions.push(this.buildTypeConditions(items, this.ifcsumSendType))
      conditions.push(this.buildTimeConditions(items, this.ifcsumSendDate))
      conditions.push(this.buildTypeConditions(items, this.installSendType))
      conditions.push(this.buildTimeConditions(items, this.installSendDate))
      conditions.push(this.buildTypeConditions(items, this.amsSendType))
      conditions.push(this.buildTimeConditions(items, this.amsSendDate))
      conditions.push(this.buildTimeConditions(items, this.ahrSendDate))
      conditions.push(this.buildTimeConditions(items, this.ensSendDate))
      conditions.push(this.buildTypeConditions(items, this.preconfigureShippingSendType))
      conditions.push(this.buildTimeConditions(items, this.preconfigureShippingSendDate))
      conditions.push(this.buildTypeConditions(items, this.overseaAgentSendType))
      conditions.push(this.buildTimeConditions(items, this.overseaAgentSendDate))
      for (let i = 0; i < conditions.length; i++) {
        if (conditions[i].length > 0) {
          txtContent += txtContent.length > 0 ? ' ' + this.operator + ' ' + conditions[i] : conditions[i]
        }
      }
      this.innerVisible = false
      this.$emit('callback', { value: { operator: this.operator, items }, txtContent })
    },
    buildTypeConditions(items, type) {
      if (type.value) {
        items.push({ fieldName: 'edi.SEND_TYPE', operator: type.condition, value: type.value, ediType: type.ediType })
        return this.buildSendTypeTxt(type)
      } else if (type.values.length > 0) {
        items.push({ fieldName: 'edi.SEND_TYPE', operator: type.condition, value: type.values, ediType: type.ediType })
        return this.buildSendTypeTxt(type)
      }
      return ''
    },
    buildTimeConditions(items, time) {
      if (time.condition === OPERATOR_DATE_ITEM.code) {
        if (typeof time.value === 'number') {
          let start = ''
          let end = ''
          let value = this.getDateItemRange(time.value)
          if (value[0] || isNumber(value[0])) {
            start = `,start=${value[0]}`
          }
          if (value[1] || isNumber(value[1])) {
            end = `,end=${value[1]}`
          }
          value = `type=date${start}${end}`
          items.push({ fieldName: 'edi.DATE_CREATED', fieldType: 'FIELD_DATE_RANGE', operator: OPERATOR_RANGE.code, value, originValue: time.value, ediType: time.ediType })
          return this.buildSendTimeTxtDateItem(time)
        }
      } else {
        if (time.condition === OPERATOR_RANGE.code) {
          let [start, end] = time.values
          if (start || end) {
            if (start || isNumber(start)) {
              start = `,start=${start}` + ' 00:00:00'
            }
            if (end || isNumber(end)) {
              end = `,end=${end}` + ' 23:59:59'
            }
            items.push({ fieldName: 'edi.DATE_CREATED', fieldType: 'FIELD_DATE_RANGE', operator: time.condition, value: `type=date${start}${end}`, originValue: time.values, ediType: time.ediType })
            return this.buildSendTimeTxtDateRange(time)
          }
        } else if (time.condition === OPERATOR_IS_NULL.code) {
          items.push({ fieldName: 'edi.DATE_CREATED', fieldType: 'FIELD_DATE_RANGE', operator: time.condition, value: time.condition, originValue: time.values, ediType: time.ediType })
          return this.buildSendTimeTxtIsNull(time)
        } else if (time.condition === OPERATOR_IS_NOT_NULL.code) {
          items.push({ fieldName: 'edi.DATE_CREATED', fieldType: 'FIELD_DATE_RANGE', operator: time.condition, value: time.condition, originValue: time.values, ediType: time.ediType })
          return this.buildSendTimeTxtIsNotNull(time)
        }
      }
      return ''
    },
    buildReceiptTimeConditions(items, time) {
      if (time.condition === OPERATOR_DATE_ITEM.code) {
        if (typeof time.value === 'number') {
          let start = ''
          let end = ''
          let value = this.getDateItemRange(time.value)
          if (value[0] || isNumber(value[0])) {
            start = `,start=${value[0]}`
          }
          if (value[1] || isNumber(value[1])) {
            end = `,end=${value[1]}`
          }
          value = `type=date${start}${end}`
          items.push({ fieldName: 'edi.RECEIPT_DATE', fieldType: 'FIELD_DATE_RANGE', operator: OPERATOR_RANGE.code, value, originValue: time.value, ediType: time.ediType })
          return this.buildSendTimeTxtDateItem(time)
        }
      } else {
        if (time.condition === OPERATOR_RANGE.code) {
          let [start, end] = time.values
          if (start || end) {
            if (start || isNumber(start)) {
              start = `,start=${start}` + ' 00:00:00'
            }
            if (end || isNumber(end)) {
              end = `,end=${end}` + ' 23:59:59'
            }
            items.push({ fieldName: 'edi.RECEIPT_DATE', fieldType: 'FIELD_DATE_RANGE', operator: time.condition, value: `type=date${start}${end}`, originValue: time.values, ediType: time.ediType })
            return this.buildSendTimeTxtDateRange(time)
          }
        } else if (time.condition === OPERATOR_IS_NULL.code) {
          items.push({ fieldName: 'edi.RECEIPT_DATE', fieldType: 'FIELD_DATE_RANGE', operator: time.condition, value: time.condition, originValue: time.values, ediType: time.ediType })
          return this.buildSendTimeTxtIsNull(time)
        } else if (time.condition === OPERATOR_IS_NOT_NULL.code) {
          items.push({ fieldName: 'edi.RECEIPT_DATE', fieldType: 'FIELD_DATE_RANGE', operator: time.condition, value: time.condition, originValue: time.values, ediType: time.ediType })
          return this.buildSendTimeTxtIsNotNull(time)
        }
      }
      return ''
    },
    getDateItemRange(value) {
      const range = []
      switch (value) {
        case 0:
          range[0] = moment()
            .week(moment().week())
            .startOf('isoWeek')
            .format('YYYY-MM-DD')
          range[1] = moment()
            .week(moment().week())
            .endOf('isoWeek')
            .format('YYYY-MM-DD')
          break
        case 1:
          range[0] = moment()
            .week(moment().week() - 1)
            .startOf('isoWeek')
            .format('YYYY-MM-DD')
          range[1] = moment()
            .week(moment().week() - 1)
            .endOf('isoWeek')
            .format('YYYY-MM-DD')
          break
        case 2:
          range[0] = moment()
            .week(moment().week() + 1)
            .startOf('isoWeek')
            .format('YYYY-MM-DD')
          range[1] = moment()
            .week(moment().week() + 1)
            .endOf('isoWeek')
            .format('YYYY-MM-DD')
          break
        case 3:
          range[0] = moment()
            .month(moment().month())
            .startOf('month')
            .format('YYYY-MM-DD')
          range[1] = moment()
            .month(moment().month())
            .endOf('month')
            .format('YYYY-MM-DD')
          break
        case 4:
          range[0] = moment()
            .month(moment().month() - 1)
            .startOf('month')
            .format('YYYY-MM-DD')
          range[1] = moment()
            .month(moment().month() - 1)
            .endOf('month')
            .format('YYYY-MM-DD')
          break
        case 5:
          range[0] = moment()
            .month(moment().month() + 1)
            .startOf('month')
            .format('YYYY-MM-DD')
          range[1] = moment()
            .month(moment().month() + 1)
            .endOf('month')
            .format('YYYY-MM-DD')
          break
      }
      range[0] = range[0] + ' 00:00:00'
      range[1] = range[1] + ' 23:59:59'
      return range
    },
    buildSendTypeTxt(val) {
      const arr = val.condition === 'IN' ? val.values : [val.value]
      const names = Array.from(arr, p => {
        const target = ChargeItemTarget.getChargeItemTargetByCode2(p)
        return this.$store.getters.isZh ? target.chineseName : target.code
      }).join(',')
      if (val.ediType === 1) {
        return `${this.$t('Message.BookingEdiSendType')}（${names}）`
      }
      if (val.ediType === 2) {
        return `${this.$t('SeaExport.BL_EDI_SendChannel')}（${names}）`
      }
      if (val.ediType === 11) {
        return `${this.$t('SeaExport.VGM_EDI_SendChannel')}（${names}）`
      }
      if (val.ediType === 7) {
        return `${this.$t('SeaExport.CleanManifest_EDI_SendChannel')}（${names}）`
      }
      if (val.ediType === 4) {
        return `${this.$t('SeaExport.Packing_EDI_SendChannel')}（${names}）`
      }
      if (val.ediType === 10) {
        return `${this.$t('SeaExport.AMS_EDI_SendChannel')}（${names}）`
      }
      if (val.ediType === 6) {
        return `${this.$t('SeaExport.PreShippingBill_EDI_SendChannel')}（${names}）`
      }
      if (val.ediType === JCL_EDI_TYPE.code) {
        return `${this.$t('SeaExport.OverseaAgent_EDI_SendChannel')}（${names}）`
      }
      return ``
    },
    buildSendTimeTxtDateItem(val) {
      const shortcutDate = this.shortcutDates.find(p => p.value === val.value)
      if (val.ediType === 1) {
        return `${this.$t('CargoMsg.Cargo_BookingSendDate')}（${shortcutDate.label}）`
      }
      if (val.ediType === 2) {
        return `${this.$t('SeaExport.BL_EDI_SendTime')}（${shortcutDate.label}）`
      }
      if (val.ediType === 11) {
        return `${this.$t('SeaExport.VGM_EDI_EDISendTime')}（${shortcutDate.label}）`
      }
      if (val.ediType === 7) {
        return `${this.$t('SeaExport.CleanManifest_EDI_SendTime')}（${shortcutDate.label}）`
      }
      if (val.ediType === 4) {
        return `${this.$t('SeaExport.Packing_EDI_SendTime')}（${shortcutDate.label}）`
      }
      if (val.ediType === 10) {
        return `${this.$t('SeaExport.AMS_EDI_SendTime')}（${shortcutDate.label}）`
      }
      if (val.ediType === 8) {
        return `${this.$t('SeaExport.AHR_EDI_SendTime')}（${shortcutDate.label}）`
      }
      if (val.ediType === 38) {
        return `${this.$t('SeaExport.ENS_EDI_SendTime')}（${shortcutDate.label}）`
      }
      if (val.ediType === 6) {
        return `${this.$t('SeaExport.PreShippingBill_EDI_SendTime')}（${shortcutDate.label}）`
      }
      if (val.ediType === JCL_EDI_TYPE.code) {
        return `${this.$t('SeaExport.OverseaAgent_EDI_SendTime')}（${shortcutDate.label}）`
      }
      if (val.ediType === BC_EDI_TYPE.code) {
        return `${this.$t('CargoMsg.Cargo_BookingReceiptDate')}（${shortcutDate.label}）`
      }
      return ''
    },
    buildSendTimeTxtDateRange(val) {
      if (val.ediType === 1) {
        return `${this.$t('CargoMsg.Cargo_BookingSendDate')}（${val.values[0]}-${val.values[1]}）`
      }
      if (val.ediType === 2) {
        return `${this.$t('SeaExport.BL_EDI_SendTime')}（${val.values[0]}-${val.values[1]}）`
      }
      if (val.ediType === 11) {
        return `${this.$t('SeaExport.VGM_EDI_EDISendTime')}（${val.values[0]}-${val.values[1]}）`
      }
      if (val.ediType === 7) {
        return `${this.$t('SeaExport.CleanManifest_EDI_SendTime')}（${val.values[0]}-${val.values[1]}）`
      }
      if (val.ediType === 4) {
        return `${this.$t('SeaExport.Packing_EDI_SendTime')}（${val.values[0]}-${val.values[1]}）`
      }
      if (val.ediType === 10) {
        return `${this.$t('SeaExport.AMS_EDI_SendTime')}（${val.values[0]}-${val.values[1]}）`
      }
      if (val.ediType === 8) {
        return `${this.$t('SeaExport.AHR_EDI_SendTime')}（${val.values[0]}-${val.values[1]}）`
      }
      if (val.ediType === 38) {
        return `${this.$t('SeaExport.ENS_EDI_SendTime')}（${val.values[0]}-${val.values[1]}）`
      }
      if (val.ediType === 6) {
        return `${this.$t('SeaExport.PreShippingBill_EDI_SendTime')}（${val.values[0]}-${val.values[1]}）`
      }
      if (val.ediType === JCL_EDI_TYPE.code) {
        return `${this.$t('SeaExport.OverseaAgent_EDI_SendTime')}（${val.values[0]}-${val.values[1]}）`
      }
      if (val.ediType === BC_EDI_TYPE.code) {
        return `${this.$t('CargoMsg.Cargo_BookingReceiptDate')}（${val.values[0]}-${val.values[1]}）`
      }
      return ''
    },
    buildSendTimeTxtIsNull(val) {
      if (val.ediType === 1) {
        return `${this.$t('CargoMsg.Cargo_BookingSendDate')}（${this.$t('advanceSearchForm.Is_Null')}）`
      }
      if (val.ediType === 2) {
        return `${this.$t('SeaExport.BL_EDI_SendTime')}（${this.$t('advanceSearchForm.Is_Null')}）`
      }
      if (val.ediType === 11) {
        return `${this.$t('SeaExport.VGM_EDI_EDISendTime')}（${this.$t('advanceSearchForm.Is_Null')}）`
      }
      if (val.ediType === 7) {
        return `${this.$t('SeaExport.CleanManifest_EDI_SendTime')}（${this.$t('advanceSearchForm.Is_Null')}）`
      }
      if (val.ediType === 4) {
        return `${this.$t('SeaExport.Packing_EDI_SendTime')}（${this.$t('advanceSearchForm.Is_Null')}）`
      }
      if (val.ediType === 10) {
        return `${this.$t('SeaExport.AMS_EDI_SendTime')}（${this.$t('advanceSearchForm.Is_Null')}）`
      }
      if (val.ediType === 8) {
        return `${this.$t('SeaExport.AHR_EDI_SendTime')}（${this.$t('advanceSearchForm.Is_Null')}）`
      }
      if (val.ediType === 38) {
        return `${this.$t('SeaExport.ENS_EDI_SendTime')}（${this.$t('advanceSearchForm.Is_Null')}）`
      }
      if (val.ediType === 6) {
        return `${this.$t('SeaExport.PreShippingBill_EDI_SendTime')}（${this.$t('advanceSearchForm.Is_Null')}）`
      }
      if (val.ediType === JCL_EDI_TYPE.code) {
        return `${this.$t('SeaExport.OverseaAgent_EDI_SendTime')}（${this.$t('advanceSearchForm.Is_Null')}）`
      }
      if (val.ediType === BC_EDI_TYPE.code) {
        return `${this.$t('CargoMsg.Cargo_BookingReceiptDate')}（${this.$t('advanceSearchForm.Is_Null')}）`
      }
      return ''
    },
    buildSendTimeTxtIsNotNull(val) {
      if (val.ediType === 1) {
        return `${this.$t('CargoMsg.Cargo_BookingSendDate')}（${this.$t('advanceSearchForm.Is_Not_Null')}）`
      }
      if (val.ediType === 2) {
        return `${this.$t('SeaExport.BL_EDI_SendTime')}（${this.$t('advanceSearchForm.Is_Not_Null')}）`
      }
      if (val.ediType === 11) {
        return `${this.$t('SeaExport.VGM_EDI_EDISendTime')}（${this.$t('advanceSearchForm.Is_Not_Null')}）`
      }
      if (val.ediType === 7) {
        return `${this.$t('SeaExport.CleanManifest_EDI_SendTime')}（${this.$t('advanceSearchForm.Is_Not_Null')}）`
      }
      if (val.ediType === 4) {
        return `${this.$t('SeaExport.Packing_EDI_SendTime')}（${this.$t('advanceSearchForm.Is_Not_Null')}）`
      }
      if (val.ediType === 10) {
        return `${this.$t('SeaExport.AMS_EDI_SendTime')}（${this.$t('advanceSearchForm.Is_Not_Null')}）`
      }
      if (val.ediType === 8) {
        return `${this.$t('SeaExport.AHR_EDI_SendTime')}（${this.$t('advanceSearchForm.Is_Not_Null')}）`
      }
      if (val.ediType === 38) {
        return `${this.$t('SeaExport.ENS_EDI_SendTime')}（${this.$t('advanceSearchForm.Is_Not_Null')}）`
      }
      if (val.ediType === 6) {
        return `${this.$t('SeaExport.PreShippingBill_EDI_SendTime')}（${this.$t('advanceSearchForm.Is_Not_Null')}）`
      }
      if (val.ediType === JCL_EDI_TYPE.code) {
        return `${this.$t('SeaExport.OverseaAgent_EDI_SendTime')}（${this.$t('advanceSearchForm.Is_Not_Null')}）`
      }
      if (val.ediType === BC_EDI_TYPE.code) {
        return `${this.$t('CargoMsg.Cargo_BookingReceiptDate')}（${this.$t('advanceSearchForm.Is_Not_Null')}）`
      }
      return ''
    },
    onReset() {
      this.sendType.value = ''
      this.sendType.values = []
      this.sendTime.value = ''
      this.sendTime.values = ['', '']
      this.receiptTime.value = ''
      this.receiptTime.values = ['', '']
      this.ladingBillSendType.value = ''
      this.ladingBillSendType.values = []
      this.ladingBillSendDate.value = ''
      this.ladingBillSendDate.values = ['', '']
      this.vgmSendType.value = ''
      this.vgmSendType.values = []
      this.vgmSendDate.value = ''
      this.vgmSendDate.values = ['', '']
      this.ifcsumSendType.value = ''
      this.ifcsumSendType.values = []
      this.ifcsumSendDate.value = ''
      this.ifcsumSendDate.values = ['', '']
      this.installSendType.value = ''
      this.installSendType.values = []
      this.installSendDate.value = ''
      this.installSendDate.values = ['', '']
      this.amsSendType.value = ''
      this.amsSendType.values = []
      this.amsSendDate.value = ''
      this.amsSendDate.values = ['', '']
      this.ahrSendDate.value = ''
      this.ahrSendDate.values = ['', '']
      this.ensSendDate.value = ''
      this.ensSendDate.values = ['', '']
      this.preconfigureShippingSendType.value = ''
      this.preconfigureShippingSendType.values = []
      this.preconfigureShippingSendDate.value = ''
      this.preconfigureShippingSendDate.values = ['', '']
      this.overseaAgentSendType.value = ''
      this.overseaAgentSendType.values = []
      this.overseaAgentSendDate.value = ''
      this.overseaAgentSendDate.values = ['', '']
    },
    async fetchEDITemplateList() {
      const self = this
      self.loading = getLoading()
      await getEDITemplate({}).then(result => {
        this.templateList = result.data
      }).finally(
        self.loading.close()
      )
      if (this.templateList) {
        const bookingEdiSendTypeList = []
        const blEdiSendTypeList = []
        const cleanManifestEdiSendTypeList = []
        const packingEdiSendTypeList = []
        const preShippingBillEdiSendTypeList = []
        const overseaAgentSendTypeList = []
        for (const item of this.templateList) {
          if (item.sendType && item.sendType.length > 0) {
            // 订舱EDI
            if (item.templateType === 1) {
              bookingEdiSendTypeList.push(item.sendType)
            }
            // 提单EDI
            if (item.templateType === 2) {
              blEdiSendTypeList.push(item.sendType)
            }
            // 清洁舱单EDI
            if (item.templateType === 7 || item.templateType === 27) {
              cleanManifestEdiSendTypeList.push(item.sendType)
            }
            // 预配舱单EDI
            if (item.templateType === 6 || item.templateType === 26) {
              preShippingBillEdiSendTypeList.push(item.sendType)
            }
            // 提箱单EDI
            if (item.templateType === 4) {
              packingEdiSendTypeList.push(item.sendType)
            }
            // 海外代理EDI
            if (item.templateType === JCL_EDI_TYPE.code) {
              overseaAgentSendTypeList.push(item.sendType)
            }
          }
        }
        if (bookingEdiSendTypeList && bookingEdiSendTypeList.length > 0) {
          this.bookingEdiSendTypeList = this.MODEL_TYPES.filter(item => bookingEdiSendTypeList.includes(item.code))
        }
        if (blEdiSendTypeList && blEdiSendTypeList.length > 0) {
          this.blEdiSendChannelList = this.MODEL_TYPES.filter(item => blEdiSendTypeList.includes(item.code))
        }
        if (cleanManifestEdiSendTypeList && cleanManifestEdiSendTypeList.length > 0) {
          this.cleanManifestEdiSendTypeList = this.MODEL_TYPES.filter(item => cleanManifestEdiSendTypeList.includes(item.code))
        }
        if (packingEdiSendTypeList && packingEdiSendTypeList.length > 0) {
          this.packingEdiSendTypeList = this.MODEL_TYPES.filter(item => packingEdiSendTypeList.includes(item.code))
        }
        if (preShippingBillEdiSendTypeList && preShippingBillEdiSendTypeList.length > 0) {
          this.preShippingBillEdiSendTypeList = this.MODEL_TYPES.filter(item => preShippingBillEdiSendTypeList.includes(item.code))
        }
        if (overseaAgentSendTypeList && overseaAgentSendTypeList.length > 0) {
          this.overseaAgentSendTypeList = this.MODEL_TYPES.filter(item => overseaAgentSendTypeList.includes(item.code))
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
#app #app-main .edi-state-query-dialog ::v-deep {
  .el-select__tags {
    padding-left: 10px;
    span {
      display: contents;
      height: 100%;
    }
  }
}
</style>
